<template>
    <div class="d-flex justify-content-center">
        <div style="width: 374px; height: 800px; border-radius: 30px;" class="my-4 shadow">

            <phone-header></phone-header>

            <slot name="header"></slot>

            <slot></slot>

            <slot name="tabNav"></slot>

            <div class="d-flex justify-content-center position-relative" style="bottom: -20px;">
                <div style="width: 120px; height: 4px" class="rounded bg-secondary">
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import GalleryGridRenderer from "../views/gallery/GalleryGridRenderer.vue";
    import PhoneHeader from "./PhoneHeader.vue";
    export default {
        name: 'PhoneContainer',
        components: {PhoneHeader, GalleryGridRenderer},
        props: {
            view: Object
        },
        data () {
            return {
                model: webase.model
            }
        },
        mounted () {
        },
        methods: {
            importantMethodHere () {
            }
        }
    }
</script>

<style>

</style>
